'use strict';

function ErrorEventCount() {
  return events => {
    let count = 0;
    for (let event of events) {
      if (event.is_error) { count++; }
    }
    return count;
  }
}

export default angular.module('leptonApp.ErrorEventCount', [])
  .filter('errorEventCount', [ErrorEventCount])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/filter/event-filter/error-count.filter.js